import React, { useEffect, useState } from "react";

export default function Countdown({ date, className = "" }) {
  const target = new Date(date).getTime();
  const calc = () => {
    const diff = Math.max(0, target - Date.now());
    return {
      days: Math.floor(diff / 86400000),
      hours: Math.floor((diff / 3600000) % 24),
      mins: Math.floor((diff / 60000) % 60),
      secs: Math.floor((diff / 1000) % 60),
    };
  };
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, [date]);

  const unit = (v, l) => (
    <div className="flex flex-col items-center" data-testid={`countdown-${l}`}>
      <span className="font-serif text-2xl md:text-3xl text-neutral-900 tabular-nums">{String(v).padStart(2, "0")}</span>
      <span className="text-[9px] uppercase tracking-[0.2em] text-neutral-400 mt-1">{l}</span>
    </div>
  );

  return (
    <div className={`flex items-center gap-4 md:gap-6 ${className}`}>
      {unit(t.days, "Days")}
      <span className="text-neutral-900/30 text-xl -mt-3">:</span>
      {unit(t.hours, "Hrs")}
      <span className="text-neutral-900/30 text-xl -mt-3">:</span>
      {unit(t.mins, "Min")}
      <span className="text-neutral-900/30 text-xl -mt-3">:</span>
      {unit(t.secs, "Sec")}
    </div>
  );
}
